import React, { memo } from 'react'

import {
  Button,
  Icon,
  Download2,
  Book2,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

const linkAttrs = { target: '_blank', rel: 'noopener noreferrer' }
const downloadIcon = <Icon svgComponent={Download2} color="dark" size="small" notSpaced />
const guideIcon = <Icon svgComponent={Book2} color="dark" size="small" notSpaced />

function DccRowSubmenu({ downloadLink = undefined, guideLink = undefined }) {
  return (
    <ul className="dcc-bridge-popover__submenu">
      <li>
        <Button
          href={downloadLink}
          linkAttributes={linkAttrs}
          icon={downloadIcon}
          type="ghost"
          size="small"
          variant="with-icon"
          customClass="dcc-bridge-popover__submenu-link cgt-body-base-semibold"
        >
          Download Plugin
        </Button>
      </li>
      <li>
        <Button
          href={guideLink}
          linkAttributes={linkAttrs}
          icon={guideIcon}
          type="ghost"
          size="small"
          variant="with-icon"
          customClass="dcc-bridge-popover__submenu-link"
        >
          Guide
        </Button>
      </li>
    </ul>
  )
}

DccRowSubmenu.propTypes = {
  downloadLink: string,
  guideLink: string,
}

export default memo(DccRowSubmenu)
